import type { Accept } from "react-dropzone";

export const TEMPLATE_ACCEPT: Accept = {
    "application/pdf": [".pdf"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
    ],
};

export const TEMPLATE_MAX_FILE_MB = 25;
export const TEMPLATE_MAX_FILE_BYTES = TEMPLATE_MAX_FILE_MB * 1024 * 1024;
export const TEMPLATE_REJECTION_COPY =
    "Only .xlsx and .pdf templates are supported";
export const TEMPLATE_INVALID_TYPE_DESCRIPTION =
    "not an .xlsx or .pdf template";
